import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [doctorId, setDoctorId] = useState(null);
    const [hospitalID, setHospitalID] = useState(null);
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userVerified, setUserVerified] = useState();
    const [accessToken, setAccessToken] = useState();

    useEffect(() => {
        const storedEmail = localStorage.getItem('userEmail');
        const storedHospitalID = localStorage.getItem('doctorHospotalId');
        const storedDoctorID = localStorage.getItem('doctorID');
        const userStatus = localStorage.getItem('userStatus');
        const storedAccessToken = localStorage.getItem('storedAccessToken');

        if (storedEmail) {
            setEmail(storedEmail);
            setHospitalID(storedHospitalID);
            setDoctorId(storedDoctorID);
            setUserVerified(userStatus);
            setAccessToken(storedAccessToken);
        }
        setLoading(false);
    }, []);

    const login = (emailFromGoogle, doctorID, hospital_id, status, accessToken) => {
        setEmail(emailFromGoogle);
        setHospitalID(hospital_id);
        setUserVerified(status);
        setDoctorId(doctorID);
        setAccessToken(accessToken);

        localStorage.setItem('doctorID', doctorID);
        localStorage.setItem('doctorHospotalId', hospital_id);
        localStorage.setItem('userEmail', emailFromGoogle);
        localStorage.setItem('userStatus', status);
        localStorage.setItem('storedAccessToken', accessToken);
    };

    const logout = () => {
        setEmail(null);
        setDoctorId(null);
        localStorage.removeItem('doctorID');
        localStorage.removeItem('doctorHospotalId');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userStatus');
        localStorage.removeItem('storedAccessToken');
    };

    const updateUserStatus = (status) =>{
        console.log(status);
        setUserVerified(status);    
        localStorage.setItem('userStatus', status);
    }

    const updateHospitalID = (id) => {
        setHospitalID(id);
        localStorage.setItem('doctorHospotalId', id);
    }

    const setAccessTokenValue = (token) => {
        setAccessToken(token);
        localStorage.setItem("storedAccessToken", token);
    };


    return (
        <AuthContext.Provider value={{ email, doctorId, hospitalID, login, logout, loading, userVerified, accessToken, updateUserStatus, setAccessTokenValue, updateHospitalID }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
